import type { LoopClip } from '../audio/types'

const DEFAULT_CLIP_DURATION = 16 // 16 steps = 1 bar (4/4)

function createClip(id: string, startStep: number, durationSteps: number, audioOffset: number): LoopClip {
  return { id, startStep, durationSteps, audioOffset }
}

export function createDefaultClips(totalSteps: number): LoopClip[] {
  const clips: LoopClip[] = []
  const firstDuration = Math.min(DEFAULT_CLIP_DURATION, totalSteps)

  if (firstDuration > 0) {
    clips.push(createClip(crypto.randomUUID(), 0, firstDuration, 0))
  }

  const secondStart = DEFAULT_CLIP_DURATION
  if (totalSteps > secondStart) {
    const secondDuration = Math.min(DEFAULT_CLIP_DURATION, totalSteps - secondStart)
    clips.push(
      createClip(
        crypto.randomUUID(),
        secondStart,
        secondDuration,
        secondStart, // audioOffset matches startStep for simplicity
      ),
    )
  }

  return clips
}

export function snapToGrid(step: number, gridSize: number): number {
  if (gridSize <= 0) return step
  return Math.round(step / gridSize) * gridSize
}

export function clampStep(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value))
}

export function stepsToDurationSeconds(steps: number, bpm: number): number {
  const stepDuration = (60 / bpm) * 0.25
  return steps * stepDuration
}
